import { CourseDef } from '../../../../types';
import L5234447 from './5234447';
// import L5234448 from './5234448';
import L5234449 from './5234449';

export const salaDeSinaisAoVivo: CourseDef = {
  courseTitle: 'SALA DE SINAIS AO VIVO',
  lessons: [L5234447, 
    // L5234448,
     L5234449],
};

